import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import { WrittenAccountPreviewsAll } from "./WrittenAccountPreviewsAll";
import { WrittenAccountPreviewsClosed } from "./WrittenAccountPreviewsClosed";
import { WrittenAccountPreviewsOpen } from "./WrittenAccountPreviewsOpen";

export const WrittenAccountsView = () => {
	return (
		<EntityPreviewsLayout
			title="Written Accounts"
			storageKey="agent_account_written_view"
			tabs={[
				{
					id: "all",
					label: "All",
					Component: WrittenAccountPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					Component: WrittenAccountPreviewsOpen,
					isDefault: true,
				},
				{
					id: "closed",
					label: "Closed",
					Component: WrittenAccountPreviewsClosed,
				},
			]}
		/>
	);
};
